// Shared widths and grids for the customer app, so every theme and page
// grows the same way with the screen: the full width on phones, a 768px
// column on tablets, and on desktop the whole browser window less a margin
// (16px a side from lg, 32px from xl), up to 1920px on very wide monitors —
// where the bottom bar gives way to the header navigation (CustomerDesktopNav,
// from the lg breakpoint). Sections inside add their own px-4 as on phones, so
// headers and content stay lined up.

// Catalogue pages: home, categories, product lists.
export const CUSTOMER_PAGE = 'w-full max-w-3xl lg:max-w-[calc(100%_-_2rem)] xl:max-w-[min(100%_-_4rem,1920px)] mx-auto';

// Forms and single-purpose pages (profile details, order tracking): a
// comfortable column on desktop rather than fields stretched across a wide screen.
export const CUSTOMER_COLUMN = 'w-full max-w-3xl mx-auto';

// Lists of cards on account pages (orders, addresses): one column on phones and
// tablets, two from lg, three on wide screens. Pages add their own gap.
export const CARD_GRID = 'grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 items-start';

// Account pages made of two groups of cards (profile, order details): stacked on
// phones and tablets — the first group, then the second — side by side from lg.
export const TWO_COLUMNS = 'space-y-4 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-6 lg:items-start';

// Product cards: 2 across on phones, up to 8 on a wide desktop — more columns
// as the page widens, so cards stay about 190–230px wide instead of growing.
export const PRODUCT_GRID = 'grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 min-[1800px]:grid-cols-8 gap-3 sm:gap-4';

// "Shop by category" tiles.
export const CATEGORY_GRID = 'grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 2xl:grid-cols-10 gap-3 sm:gap-4';

// Small round category icons with a label underneath.
export const CATEGORY_ICON_GRID = 'grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-8 xl:grid-cols-10 2xl:grid-cols-12 gap-y-5 gap-x-3';
